import React from "react";

function Spinner(props) {
  return (
    <svg
      className="spinner"
      width="65px"
      height="65px"
      viewBox="0 0 66 66"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        className="spinnerCircle"
        fill="none"
        strokeWidth="6"
        strokeLinecap="round"
        cx="33"
        cy="33"
        r="30"
      />
    </svg>
  );
}

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner.js